<nav
  class="sidebar"
  [class.collapsed]="!mobileDrawer && isCollapsed()"
  [class.mobile-drawer-nav]="mobileDrawer"
  [style.width.px]="mobileDrawer ? undefined : (isCollapsed() ? 64 : 256)"
>
  <!-- Brand and Toggle (desktop only) -->
  @if (!mobileDrawer) {
  <div class="sidebar-header">
    <tenant-brand
      [authUser]="authUser()"
      [isCollapsed]="isCollapsed()"
      logoVariant="color"
      class="sidebar-brand"
    ></tenant-brand>
    <button
      class="sidebar-toggle"
      (click)="toggleCollapse()"
      [attr.aria-label]="isCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
    >
      <span class="fe" [class.fe-menu]="isCollapsed()" [class.fe-x]="!isCollapsed()"></span>
    </button>
  </div>
  }

  <!-- Mobile drawer: brand at top of menu content (temporarily commented out)
  @if (mobileDrawer && authUser()) {
  <div class="mobile-drawer-brand">
    <tenant-brand
      [authUser]="authUser()"
      [isCollapsed]="false"
      class="mobile-drawer-brand-inner"
    ></tenant-brand>
  </div>
  }
  -->

  <!-- Navigation Menu -->
  <div class="sidebar-nav" *ngIf="authUser()">
    <!-- Insights Group - Always shown for all tenant users -->
    <tenant-sidebar-nav-group
      [group]="insightsGroup"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="insights"
    ></tenant-sidebar-nav-group>

    <!-- Operations Group -->
    <tenant-sidebar-nav-group
        *ngxPermissionsOnly="[
          roles.TENANT_ADMIN,
          roles.TENANT_TERMINAL_MANAGER,
          roles.TENANT_BOOKING_MANAGER,
          roles.TERMINAL_BOOKING_CLERK,
          roles.TENANT_DIRECTOR,
          roles.TENANT_ACCOUNTANT,
          roles.TENANT_MANAGEMENT_MEMBER,
        ]"
      [group]="operationsGroup"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="operations"
    ></tenant-sidebar-nav-group>

    <!-- Cash Group (cash plan Phase E). Parcel Manager: counts the parcel desk in.
         Clerks: My cash. Each item is narrowed further by its own roles. -->
    <tenant-sidebar-nav-group
      *ngxPermissionsOnly="[
        roles.TENANT_ADMIN,
        roles.TENANT_DIRECTOR,
        roles.TENANT_ACCOUNTANT,
        roles.TENANT_MANAGEMENT_MEMBER,
        roles.TENANT_TERMINAL_MANAGER,
        roles.TENANT_BOOKING_MANAGER,
        roles.TENANT_PARCEL_MANAGER,
        roles.TERMINAL_BOOKING_CLERK,
        roles.TERMINAL_PARCEL_CLERK,
      ]"
      [group]="cashGroup"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="cash"
    ></tenant-sidebar-nav-group>

    <!-- Parcels Group -->
    <tenant-sidebar-nav-group
        *ngxPermissionsOnly="[
          roles.TENANT_ADMIN,
          roles.TENANT_TERMINAL_MANAGER,
          roles.TENANT_PARCEL_MANAGER,
          roles.TERMINAL_PARCEL_CLERK,
          roles.BUS_STOP_MANAGER,
          roles.BUS_STOP_CLERK
        ]"
      [group]="parcelsGroupForViewer()"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="parcels"
    ></tenant-sidebar-nav-group>

    <!-- Manage Group (terminal-based managers only) -->
    <tenant-sidebar-nav-group
      *ngxPermissionsOnly="[
        roles.TENANT_TERMINAL_MANAGER,
        roles.TENANT_BOOKING_MANAGER,
        roles.TENANT_PARCEL_MANAGER
      ]"
      [group]="manageGroup"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="manage"
    ></tenant-sidebar-nav-group>

    <!-- Routes Group (admin only) -->
    <tenant-sidebar-nav-group
      *ngxPermissionsOnly="[roles.TENANT_ADMIN]"
      [group]="routesGroup"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="routes"
    ></tenant-sidebar-nav-group>

    <!-- Fleet Group -->
    <tenant-sidebar-nav-group
        *ngxPermissionsOnly="[
          roles.TENANT_ADMIN,
          roles.TENANT_TERMINAL_MANAGER,
          roles.TENANT_BOOKING_MANAGER,
          roles.TENANT_CONDUCTOR
        ]"
      [group]="fleetGroup"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="fleet"
    ></tenant-sidebar-nav-group>

    <!-- Access Control Group -->
    <tenant-sidebar-nav-group
        *ngxPermissionsOnly="[
          roles.TENANT_ADMIN,
          roles.TENANT_TERMINAL_MANAGER,
          roles.TENANT_PARCEL_MANAGER,
          roles.TENANT_BOOKING_MANAGER
        ]"
      [group]="accessControlGroup"
      [isCollapsed]="mobileDrawer ? false : isCollapsed()"
      storageKey="access-control"
    ></tenant-sidebar-nav-group>

    <!-- Administration (mobile drawer only: at bottom of scrollable list) -->
    @if (mobileDrawer) {
    <tenant-sidebar-nav-group
      *ngxPermissionsOnly="[roles.TENANT_ADMIN]"
      [group]="administrationGroup"
      [isCollapsed]="false"
      storageKey="administration-mobile"
    ></tenant-sidebar-nav-group>
    }
  </div>

  <!-- Administration Section (desktop sidebar only) -->
  @if (!mobileDrawer) {
  <div class="sidebar-footer">
    <div class="admin-section" *ngxPermissionsOnly="[roles.TENANT_ADMIN]">
      <div class="admin-section-header" *ngIf="!isCollapsed() || mobileDrawer">
        <span class="admin-section-label">Administration</span>
      </div>
      <nav class="admin-nav">
        @if (isCollapsed() && !mobileDrawer) {
          <a
            routerLink="/settings/company"
            routerLinkActive="active"
            class="admin-nav-item"
            nzTooltipTitle="Settings"
            nzTooltipPlacement="right"
          >
            <span class="fe fe-settings admin-nav-icon"></span>
          </a>
          <a
            routerLink="/billing"
            routerLinkActive="active"
            class="admin-nav-item"
            nzTooltipTitle="Billing"
            nzTooltipPlacement="right"
          >
            <span class="fe fe-credit-card admin-nav-icon"></span>
          </a>
        } @else {
          <a
            routerLink="/settings/company"
            routerLinkActive="active"
            class="admin-nav-item"
          >
            <span class="fe fe-settings admin-nav-icon"></span>
            <span class="admin-nav-label">Settings</span>
          </a>
          <a
            routerLink="/billing"
            routerLinkActive="active"
            class="admin-nav-item"
          >
            <span class="fe fe-credit-card admin-nav-icon"></span>
            <span class="admin-nav-label">Billing</span>
          </a>
        }
      </nav>
    </div>
  </div>
  }

  <!-- Mobile drawer footer: user + manage account + logout -->
  @if (mobileDrawer && authUser()) {
  <div class="mobile-drawer-footer">
    <div class="mobile-drawer-user">
      <ngx-avatars [name]="authUser()!.name" size="48"></ngx-avatars>
      <div class="mobile-drawer-user-info">
        <span class="mobile-drawer-user-name">{{ authUser()!.name }}</span>
        <span class="mobile-drawer-user-role">{{ authUser()!.role }}</span>
      </div>
    </div>
    <a routerLink="/profile" class="mobile-drawer-manage-account">Manage account</a>
    <button type="button" class="mobile-drawer-logout" (click)="logoutRequest.emit()">
      Logout
    </button>
  </div>
  }
</nav>
